
export const lookupGroups: Record<string, { name: string, id: string }> = {
    bloodType: { name: "bloodType", id: "45de0786-88f3-447a-8b82-f5600b8cb9b4" },
    disabilityStatus: { name: "disabilityStatus", id: "7686eca6-3058-4b03-94c6-44eb06d3eb2e" },
    gender: { name: "gender", id: "87de918b-4225-4876-b9d2-6be7af5f601c" },
    maritalStatus: { name: "maritalStatus", id: "fc0d428e-72e6-4715-a435-60dee1a875cb" },
    nationality: { name: "nationality", id: "fdfde37d-7bce-463a-a2b5-71b0462394f7" },
    affinity: { name: "affinity", id: "d0269989-6171-494d-8903-f15c028b6063" },
    bankAccountType: { name: "bankAccountType", id: "257e3260-1073-49ae-86c9-9918ba24812b" },
    workEnvironment: { name: "workEnvironment", id: "6203a0cc-97f7-49f6-8716-b301c32300e0" },
    contractType: { name: "contractType", id: "bcc74c22-725e-44d3-9ba9-39ec42d1b38a" },
    policyType: { name: "policyType", id: "662005c4-1cd9-4032-a7fe-0c0cf13cb47f" },
    salaryPaymentMethod: { name: "salaryPaymentMethod", id: "15e9170c-049a-4401-b350-fe6302087893" },
    salaryPaymentDay: { name: "salaryPaymentDay", id: "5a2228e0-1102-4ccf-869e-7661f3af5e5b" },
    salaryCalculationType: { name: "salaryCalculationType", id: "9a819bb9-ad58-4432-a3c5-393efca8f1e7" },
    graduationStatus: { name: "graduationStatus", id: "880979a9-1048-4745-a537-92534aca37bc" },
    schoolType: { name: "schoolType", id: "ab293da5-b79a-4bae-ad08-d42805a3da9d" },
    educationStatus: { name: "educationStatus", id: "d3e46b05-294b-42dd-8984-049c86483209" },
    businessDocumentType: { name: "businessDocumentType", id: "fc878a6f-6435-484f-b00c-f2f7ff9be63c" },
    leaveAccrualPeriodType: { name: "leaveAccrualPeriodType", id: "495be8c0-1496-4f79-92b0-01ae601bbb72" },
    leaveCalculationMethod: { name: "leaveCalculationMethod", id: "79142322-8392-48b8-bb7e-a7b84a9e81b2" },
    leavePaymentType: { name: "leavePaymentType", id: "72904657-158e-4627-841b-48c66ab268bb" },
    leaveUsageMethod: { name: "leaveUsageMethod", id: "56429ca2-572a-4114-a032-fd21c210e526" },
    leaveType: { name: "leaveType", id: "1644410a-c061-4519-8d54-2029de70698d" },
    leaveAccrualTime: { name: "leaveAccrualTime", id: "6485ec47-7c83-494f-aa5f-b70f5b3dc191" },
    transferableType: { name: "transferableType", id: "deb134ce-bc31-47a2-869d-199abe75029f" },
    restrictionPeriodType: { name: "restrictionPeriodType", id: "861e91cc-5bd3-40c1-bfcf-35f468a3a7c0" },
    restrictionDurationType: { name: "restrictionDurationType", id: "493572af-a893-4423-b22d-650f611a28df" },
    targetGroupType: { name: "targetGroupType", id: "c9eb2893-5a41-4eb7-b314-1b1cc06355be" },
    approverTypes: { name: "approverTypes", id: "977eab96-d5cf-44d2-b1fb-c2613def0ce0" },
    multiApprovalTypes: { name: "multiApprovalTypes", id: "ba0bfc19-6fa6-43ff-87f1-2cf7bf8720fc" },
    approverGeneralTypes: { name: "approverGeneralTypes", id: "e9d4bd75-25c8-4e2c-8716-a90c525a6fb9" },
    approveHierarchyTypes: { name: "approveHierarchyTypes", id: "ee6230dd-6319-4c64-9c28-e1971e6afa57" },
    willBeNotifiedTypes: { name: "willBeNotifiedTypes", id: "1352818f-deae-4c00-8ddb-befcc40e1a65" },
    willBeNotifiedGeneralTypes: { name: "willBeNotifiedGeneralTypes", id: "9516ee94-227a-40a4-9159-ceaf34327466" },
    passportStatusTypes: { name: "passportStatusTypes", id: "7292a61f-45b2-4907-a4fc-153876d32e65" },
    travelInsturanceStatusTypes: { name: "travelInsturanceStatusTypes", id: "4993c2e8-e19b-4f15-850d-65df023e54ac" },
    vaccinationStatusTypes:{ name: "vaccinationStatusTypes", id: "1db211e2-28e0-48e0-b01f-30d384165feb" },
    
}

export const vaccinationStatusTypes = lookupGroups.vaccinationStatusTypes;
export const passportStatusTypes = lookupGroups.passportStatusTypes;
export const travelInsturanceStatusTypes = lookupGroups.travelInsturanceStatusTypes;

export const leaveUsageMethod = {
    daily: "655b2cf4-4e33-48d0-b6ac-68be020e69f3",
    dailyOrHourly: "943689e2-89f9-4d84-9ead-b72a95be087b",
    hourly: "f4eb714e-6a01-42bd-b071-0adbc377fe65"
}

export const leaveLimitType = {
    limited: "1318108a-cb88-4220-9f64-c89324b87a75",
    unLimited: "b11f1bbc-83cd-4f0b-ba34-70e9e9696d56"
}

export const leaveTypes = {
    marriageLeave: "1c9ed951-8352-4c57-9405-400f95b68025",
    halfDayPostnatalWorkLeave: "21a3becc-899b-4538-84df-1710ae7e63a1",
    prenatalCheckupLeave: "332a4bf3-01ba-41f4-9f16-8a7c512efb2f",
    specialLeave: "336f8e57-f6d6-4788-9e1d-1fcbc7bfebbb",
    excuseLeave: "3db755fd-ddfb-4da9-80e4-265e3d766af5",
    bereavementLeave: "3e31a5ff-c442-49e2-bc14-d9c7aef3b650",
    paternityLeave: "95038f78-179a-41c4-9c71-4e59fd662bc7",
    annualLeave: "a58d4a19-6bb4-4001-b6e3-f2487553f679",
    sickLeave: "a7070f56-0812-4ea8-ab9d-6bce06d93096",
    breastfeedingLeave: "b8540270-5c2c-41ac-83fc-b8bf1b6ed437",
    maternityLeave: "cd509d32-10c2-4588-9913-0fd2cd90dbb3",
    adoptionLeave: "d04d20d9-7d88-4a69-ae69-e1555057cd5f",
    overtimeLeave: "ece3010d-d170-42ef-aa0f-82dd41484de0"
}

export const transferableTypes = {
    transferPartOfRemaining: "08a7c33f-6753-49fa-b510-671f4a3dc894",
    notTransferable: "10fb1622-ed3f-4c08-809a-c45c30ff3cf1",
    transferAllRemaining: "810b23b7-47c0-44be-99aa-c8e1f62d333d",
}

export const leaveCalculationMethods = {
    hourly: "d32d73cb-a1be-4fc7-8c52-977a2fe508d4",
    daily: "dac20d4e-fef7-4cb7-aace-d1b2fa24a71c"

}

export const targetGroupTypeUrlList = [
    { id: "004ac603-9b03-4972-bf6e-69c1b11c256d", url: "/api/LookupData/LookupGroup/", parentId: "87de918b-4225-4876-b9d2-6be7af5f601c" },//gender: 
    { id: "148c3057-5018-4291-a595-6010c84d7af2", url: "/api/PositionInfo", parentId: "" },//position:
    { id: "8f55ead3-09bd-47e6-b991-1ebc37d98e88", url: "/api/DepartmentInfo", parentId: "" },//department:
    { id: "cd46f265-6c41-4a34-be8f-c6b5a8db24a3", url: "/api/TitleInfo", parentId: "" },//title:
    { id: "e7a1b939-3d25-4bce-ade8-43ac9a497ea9", url: "/api/OfficeInfo", parentId: "" }, //office:
]

export const leaveStatusTypes = {
    autoApproved: "2a4537fe-129e-4563-81ef-e48cc546d8d3",
    approved: "53f4236f-79b8-447b-8b2f-1030bff1b2b8",
    submittedSignature: "83b01651-a580-4201-bcd7-31d88ac35391",
    pending: "b1712699-d11f-45db-b236-f32a1fa36d8c",
    rejected: "ef480c1c-c7b3-4519-bb11-3a9548e814a9",
    demandStage: "feee1785-ce57-4bbc-a000-c5c87e2e7f54",
}

export const ApproverTypes = {
    employee: "06347f05-77ff-4831-892c-0e29a9fa643b",
    general: "3044030f-4b88-4cae-915d-8d24d23e66b2",
    position: "f8a10e08-9f87-4dfb-a780-ba85e3d98a15",
    //samePosition: "716f6086-298e-4ff6-8a10-0c429c2d47db",
}

export const WillBeNotifiedTypes = {
    employee: "81b1161d-35fc-4ebc-b881-59693abf79e6",
    general: "1ec50668-94e1-4b61-b1fe-e742f7820c79",
    position: "98f4f634-3473-4996-86da-0863b1b4878f",
    //samePosition: "8a46fcd1-c5f9-4cce-8df8-3b49683b3ec2"
}

export const MultiApprovalTypes = {
    singleApprove: "ac887835-20fb-49c8-8e00-ad4e057b300c",
    mustApproveAll: "d6932a6f-2577-4c12-b2da-cce55cf8b372"
}